import React, { createContext, useContext, useState } from 'react';

import type { ReactNode } from 'react';

interface SidebarContextProps {
  sidebarWidth: number;
  setSidebarWidth: (width: number) => void;
  isSidebarToggled: boolean;
  setSidebarToggled: (isToggled: boolean) => void;
}

const SidebarContext = createContext<SidebarContextProps | undefined>(undefined);

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
  const [sidebarWidth, setSidebarWidth] = useState(100); // Default sidebar width
  const [isSidebarToggled, setIsSidebarToggled] = useState(false);

  return (
    <SidebarContext.Provider
      value={{
        sidebarWidth,
        setSidebarWidth,
        isSidebarToggled,
        setSidebarToggled: setIsSidebarToggled,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
